import { createSlice } from '@reduxjs/toolkit';

import { LocalStorage2faKey } from '@pkg/types';

import { type Next2faAction, type Reset2faAction, type Toggle2faMintingAction, type TwoFactorAuthState } from './types';
import { recentPromptIgnored } from './utilities';

const name = 'twoFactorAuth';
const initialState: TwoFactorAuthState = {
    expiredLogin: false,
    postPurchasePopup: false,
    resetCode: false,
    requirePopup: false,
    setupFlow: false,
    showMintingPopup: false,
    showArtifactMintingPopup: false,
};

export const twoFactorAuthSlice = createSlice({
    name,
    initialState,
    reducers: {
        show2faRequirePopup(state) {
            state.requirePopup = recentPromptIgnored(LocalStorage2faKey.TimeSinceRequire);
        },
        hide2faRequirePopup(state) {
            // TODO: We should not be using `Date` within reducers,
            // as these instances cannot be serialized.
            const timeSinceRequireValue = String(new Date().getTime());
            localStorage.setItem(LocalStorage2faKey.TimeSinceRequire, timeSinceRequireValue);

            state.requirePopup = false;
        },
        show2faPostPurchasePopup(state) {
            state.postPurchasePopup = recentPromptIgnored(LocalStorage2faKey.TimeSincePostPurchase);
        },
        hide2faPostPurchasePopup(state) {
            // TODO: We should not be using `Date` within reducers,
            // as these instances cannot be serialized.
            const timeSincePostPurchaseValue = String(new Date().getTime());
            localStorage.setItem(LocalStorage2faKey.TimeSincePostPurchase, timeSincePostPurchaseValue);

            state.postPurchasePopup = false;
        },
        show2faSetupFlow(state) {
            state.setupFlow = true;
        },
        hide2faSetupFlow(state) {
            state.setupFlow = false;
        },
        show2faExpiredLogin(state, { payload }: Next2faAction) {
            state.expiredLogin = true;
            state.on2faNext = payload;
        },
        hide2faExpiredLogin(state) {
            state.expiredLogin = false;
        },
        set2faResetCode(state, { payload }: Reset2faAction) {
            state.resetCode = payload;
        },
        toggle2faMintingPopup(state, { payload }: Toggle2faMintingAction) {
            // NOTE: Using a toggle instead of separate binary show / hide methods
            // because a delay is not required.
            state.showMintingPopup = payload;
        },
        toggle2faArtifactMintingPopup(state, { payload }: Toggle2faMintingAction) {
            // todo! fix - this could rather be one toggle ^ with a type param
            state.showArtifactMintingPopup = payload;
        },
    },
});
